import React, {useState} from "react";
import Modal from "../../../../common/Modal";
import BookMemoResponse from "./BookMemoResponse";
import styled from "styled-components";
import ColorConfig from "../../../../config/ColorConfig";
import parse from 'html-react-parser';
import NoContent from "../../../../common/NoContent";
import RowSpacer from "../../../../common/styles/RowSpacer";
import BookDetailMemoDetailModal from "./BookDetailMemoDetailModal";
import BookDetailMemoEditModal from "./BookDetailMemoEditModal";

interface Props {
    isOpen: boolean
    close: () => void
    memos: BookMemoResponse[]
}

const BookDetailMemoAllModal: React.FC<Props> = ({isOpen, close, memos}) => {
    const [selectedMemo, setSelectedMemo] = useState<BookMemoResponse | null>(null)
    const [isDetailOpen, setIsDetailOpen] = useState(false)
    const [isEditOpen, setIsEditOpen] = useState(false)
    const [editMemo, setEditMemo] = useState<BookMemoResponse | null>(null)

    const openDetail = (memo: BookMemoResponse) => {
        setSelectedMemo(memo)
        setIsDetailOpen(true)
    }

    const openEdit = (memo: BookMemoResponse) => {
        setIsDetailOpen(false)
        setEditMemo(memo)
        setIsEditOpen(true)
    }

    return (
        <>
            {selectedMemo && (
                <BookDetailMemoDetailModal
                    isOpen={isDetailOpen}
                    close={() => setIsDetailOpen(false)}
                    memo={selectedMemo}
                    openEditModal={openEdit}
                />
            )}

            <BookDetailMemoEditModal isOpen={isEditOpen} close={() => setIsEditOpen(false)} memo={editMemo} />

            <Modal
                titleText={'✏️ 메모 전체 보기'}
                isShowing={isOpen}
                onClose={close}
                size={'lg'}
                body={
                    <>
                        {
                            memos.length === 0 ?
                                <>
                                    <RowSpacer/>
                                    <NoContent message={'메모가 없어요'}/>
                                    <RowSpacer/>
                                </>
                                :
                                memos.map((memo) => (
                                    <Memo key={memo.id} onClick={() => openDetail(memo)}>
                                        <PageNumber>{memo.page ?? '-'}</PageNumber>
                                        <MemoContent>{parse(memo.content)}</MemoContent>
                                    </Memo>
                                ))
                        }
                    </>
                }
            />
        </>
    )
}

const Memo = styled.div.attrs({
    className: 'col-12 clickable'
})`
    background-color: #fff9c4;
    padding: 15px;
    border-radius: 16px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    margin-bottom: 10px;
`;


const PageNumber = styled.div`
    font-size: 0.85em;
    font-weight: bold;
    margin-bottom: 5px;
    color: ${ColorConfig.Primary};
`;

const MemoContent = styled.div.attrs({})`
    font-size: 1em;
    color: #333;
    min-height: 50px;

    p {
        margin: 3px 0;
    }

    blockquote {
        background: #f1f1ef;
        border-radius: 4px;
        border: none;
        margin: 4px 0;
        padding: 10px 14px;
        color: #3b3b3b;
    }

    ul {
        list-style: disc;
        margin: 5px 0;
        padding-left: 40px;
    }

    ul li {
        margin: 0;
        padding: 2px 0;

        p {
            margin: 0;
        }
    }

    p:empty {
        display: none;
    }
`;

export default BookDetailMemoAllModal
